import { Filter } from "@/lib/interfaces/cards";

export const slugify = (s: string) =>
  s
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const transformForURL = (value: string) =>
  value.toLowerCase().replace(/\s+/g, "-");

export const buildURL = (pathname: string, params: URLSearchParams) => {
  const paramEntries = Array.from(params.entries());
  const queryString = paramEntries
    .map(([key, value]) => `${key}=${value.replace(/\|/g, ",")}`)
    .join("&");
  return queryString ? `${pathname}?${queryString}` : pathname;
};

export const getActiveFilterIds = (
  searchParams: Record<string, string | string[] | undefined> | URLSearchParams,
  filters: Filter[]
): string[] => {
  const activeIds: string[] = [];
  
  const flat = filters.flatMap((group) => {
    const groupSlug = slugify(group.filter_name);
    return group.values.map((v) => ({
      id: v.id,
      value: v.value,
      groupSlug,
    }));
  });

  const groupToValueToId: Record<string, Record<string, string>> = {};
  for (const o of flat) {
    groupToValueToId[o.groupSlug] ||= {};
    groupToValueToId[o.groupSlug][transformForURL(o.value)] = o.id;
  }

  const groups = Array.from(new Set(flat.map((o) => o.groupSlug)));
  for (const gslug of groups) {
    let rawValue: string | null = null;
    if (searchParams instanceof URLSearchParams) {
      rawValue = searchParams.get(gslug);
    } else {
      const val = searchParams[gslug];
      rawValue = Array.isArray(val) ? val.join(",") : (val || null);
    }
    
    if (rawValue) {
      const values = rawValue.split(",");
      const v2id = groupToValueToId[gslug] || {};
      for (const value of values) {
        const id = v2id[value];
        if (id) activeIds.push(id);
      }
    }
  }
  return activeIds;
};

